import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import HandshakeIcon from "@mui/icons-material/Handshake";
import StarsIcon from "@mui/icons-material/Stars";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import GroupIcon from "@mui/icons-material/Group";
import HubIcon from "@mui/icons-material/Hub";
import { motion } from "framer-motion";

export default function StatsSection() {
  const stats = [
    {
      value: "10+",
      title: "Capital Solutions",
    },
    {
      value: "50+",
      title: "Lender & Investor Relationships",
    },
    {
      value: "360°",
      title: "Transaction Management",
    },
    {
      value: "Pan-IN",
      title: "Domestic & Cross-Border Reach",
    },
  ];
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="bg-[#17274d] py-6 md:py-10">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="grid grid-cols-2 gap-y-10 md:grid-cols-4"
        >
          {stats.map((itemData, index) => (
            <motion.div
              key={index}
              variants={item}
              className={`relative flex flex-col items-center justify-center px-6 text-center ${
                index !== stats.length - 1
                  ? "md:border-r md:border-white/10"
                  : ""
              }`}
            >
              <motion.h2
                initial={{ scale: 0.8 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.6 }}
                className="mb-3 font-serif text-2xl text-[#D6B34D] md:text-4xl"
              >
                {itemData.value}
              </motion.h2>

              <p className=" text-sm  tracking-[3px] text-white/40 md:text-[12px] font-[var(--ms-body-font-family)]">
                {itemData.title}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
